import { deleteRequest } from '../..';

const deleteFloor = (LocationId: string) => deleteRequest('locations/floors', { LocationId });

export default deleteFloor;
